var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSmsReminder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99982 17.5081C6.26584 17.5081 3.22803 14.4704 3.22803 10.7364C3.22803 7.00258 6.26588 3.96484 9.99982 3.96484C13.7338 3.96484 16.7717 7.00258 16.7717 10.7364C16.7717 14.4704 13.7338 17.5081 9.99982 17.5081ZM9.99982 5.13676C6.91201 5.13676 4.3999 7.64879 4.3999 10.7365C4.3999 13.8242 6.91205 16.3363 9.99982 16.3363C13.0877 16.3363 15.5998 13.8242 15.5998 10.7365C15.5998 7.64875 13.0877 5.13676 9.99982 5.13676Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27048 13.0837C8.12231 13.0837 7.97407 13.0279 7.85997 12.9158C7.62907 12.6891 7.62571 12.3181 7.85243 12.0872L9.41407 10.4968V7.70703C9.41407 7.38344 9.67642 7.12109 10 7.12109C10.3236 7.12109 10.5859 7.38344 10.5859 7.70703V10.976L8.6886 12.9083C8.57388 13.0251 8.4222 13.0837 8.27048 13.0837Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51348 5.64536C3.34837 5.64536 3.18426 5.57595 3.06837 5.44079C2.85774 5.19513 2.88614 4.82521 3.1318 4.61458L5.44266 2.63333C5.68833 2.42267 6.05829 2.45107 6.26887 2.69681C6.4795 2.94247 6.4511 3.3124 6.20544 3.52302L3.89458 5.50427C3.78411 5.59896 3.64844 5.64536 3.51348 5.64536Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4864 5.64536C16.3514 5.64536 16.2158 5.59895 16.1053 5.50423L13.7944 3.52298C13.5487 3.31235 13.5203 2.94243 13.731 2.69676C13.9417 2.45106 14.3115 2.4227 14.5572 2.63329L16.868 4.61454C17.1137 4.82516 17.1421 5.19508 16.9315 5.44075C16.8156 5.57594 16.6515 5.64536 16.4864 5.64536Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmsReminder);
export default __webpack_public_path__ + "static/media/ic-sms-reminder.602d7b9cb6c6968b4d6127f283343f11.svg";
export { ForwardRef as ReactComponent };